import "../scss/plugins/_swiper.scss"

import TimelineSlider from './components/TimelineSlider/TimelineSlider'
import TimelineDialog from './components/TimelineDialog/TimelineDialog'

new TimelineSlider()
new TimelineDialog()